






















import { computed, defineComponent, toRefs } from '@vue/composition-api'
import { useActions } from '../../store/useActions'
import PartField from '../../components/editor/PartField.vue'
import KaiSpeaker from '../../components/transcript/KaiSpeaker.vue'
import { useCursorDestinationId } from '../../components/editor/useCursorPendingMover'

export default defineComponent({
  name: 'EditorPart',
  emits: ['show-speakers'],
  components: { KaiSpeaker, PartField },
  props: {
    part: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    //TODO: remove computed
    const { part } = toRefs(props)
    const partId = computed(() => part.value.id)
    const speakerColor = computed(() => part.value.speaker?.color)
    const speakerName = computed(
      () => part.value?.speaker?.name ?? 'Unknown speaker'
    )

    const {
      updatePart,
      openSelector,
      rewindToWord,
      splitPart,
      joinPreviousPart,
      joinNextPart
    } = useActions({
      updatePart: 'editor/updatePart',
      openSelector: 'editor/showSpeakerSelector',
      rewindToWord: 'editor/rewindToWord',
      splitPart: 'editor/splitPart',
      joinPreviousPart: 'editor/joinPreviousPart',
      joinNextPart: 'editor/joinNextPart'
    })

    const textareaId = useCursorDestinationId(partId)

    function saveChanges(partId, text) {
      console.debug(`Updating part: ${partId} `)
      console.debug(`Updating part: ${text}`)
      updatePart({ partId, text })
    }

    function showSpeakerSelector(partId, event) {
      openSelector({ partId, target: event.target })
    }

    function handleWordClick(partId, { word, offset }) {
      rewindToWord({ partId, word, offset }) //TODO: maybe pass current text too
    }

    async function handleEnter(partId, { offset, text }) {
      await updatePart({ partId, text })
      await splitPart({ partId, offset })
    }

    async function handleBackspace(partId, { text }) {
      await updatePart({ partId, text })
      await joinPreviousPart({ partId })
    }

    async function handleDelete(partId, { text }) {
      await updatePart({ partId, text })
      await joinNextPart({ partId })
    }

    return {
      speakerName,
      textareaId,
      speakerColor,
      saveChanges,
      handleEnter,
      handleDelete,
      handleBackspace,
      handleWordClick,
      showSpeakerSelector
    }
  }
})
